import {
  LinearProgress as LinearProgressMui5,
  LinearProgressProps as LinearProgressPropsMui5,
} from '@mui/material'
import { forwardRef } from 'react'

export type LinearProgressProps = LinearProgressPropsMui5

export const LinearProgress = forwardRef<HTMLSpanElement, LinearProgressProps>(function LinearProgress(
  props,
  ref
) {
  return <LinearProgressMui5 ref={ref} {...props} />
})
